export default __webpack_public_path__ + "static/media/2393.74ac6834.png";